// extracted by mini-css-extract-plugin
export default {"root":"ABVT2WhWAn","tabContent":"UY9yWsnnXY","tabContent_widthContrained":"Fy3mYUx6iT"};